<template>
  <base-page-layout title="Cashback">
    <mf-tabs-menu v-model="currentTab" :tabs="permissionedCashbackTabs" class="mt-4" />
    <router-view />
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'

export default {
  components: {
    BasePageLayout,
  },
  data: () => ({
    currentTab: null,
  }),
  computed: {
    modules() {
      return this.$getAllowedModules()
    },
    cashbackTabs() {
      return [
        {
          name: 'Cashback',
          to: '/mobile/cashback/cashback',
          tabPermission: 'mobile/cashback/cashback',
        },
        {
          name: 'Controle de CPFs',
          to: '/mobile/cashback/controle-de-cpf',
          tabPermission: 'mobile/cashback/controle-de-cpf',
        },
        {
          name: 'Ajustes de Cashback',
          to: '/mobile/cashback/ajustes',
          tabPermission: 'mobile/cashback/ajustes',
        },
        ...(this.modules.jane
          ? [
              {
                name: 'Bloqueios de Saldos',
                to: '/mobile/cashback/bloqueios-de-saldos',
                tabPermission: 'mobile/cashback/bloqueios-de-saldos',
              },
            ]
          : []),
      ]
    },
    permissionedCashbackTabs() {
      let tabs = []
      this.cashbackTabs.forEach((tab) => {
        if (this.$permissions.havePagePermission(tab.tabPermission)) {
          tabs.push(tab)
        }
      })
      return tabs
    },
  },
  watch: {
    currentTab(tab) {
      if (this.$route.path !== this.permissionedCashbackTabs[tab].to) {
        this.$router.push(this.permissionedCashbackTabs[tab].to).catch(() => {})
      }
    },
  },
  mounted() {
    this.setInitialTab()
  },
  beforeUpdate() {
    this.setInitialTab()
  },
  methods: {
    setInitialTab() {
      if (this.$route.path === '/mobile/cashback') {
        this.$router.push(this.permissionedCashbackTabs[0].to).catch(() => {})
        this.currentTab = 0
        return
      }
      const index = this.permissionedCashbackTabs.findIndex((p) => p.to === this.$route.path)
      this.currentTab = index === -1 ? 0 : index
    },
  },
}
</script>
